import { Component, Inject, Renderer2 } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import { Constants } from '../../common/constants';
import { SeoService } from 'src/app/common/seo.service';
import { DOCUMENT } from '@angular/common';

@Component({
  selector: 'app-human-machine-conversations',
  templateUrl: './human-machine-conversations.component.html',
  styleUrls: ['./human-machine-conversations.component.css']
})
export class HumanMachineConversationsComponent {
  baseUrl=Constants.baseUrl;
  webUrl=Constants.webURL;
  constructor(
    private titleService: Title,
    private metaService: Meta, private _renderer2: Renderer2,private seoService:SeoService,
    @Inject(DOCUMENT) private _document: Document,
  ) {}
  ngOnInit(): void {
    let script = this._renderer2.createElement('script');
    script.type = `application/ld+json`;
    script.text = `
{
  "@context": "https://schema.org",
  "@type": "BlogPosting",
  "mainEntityOfPage": {
    "@type": "WebPage",
    "@id": "https://mitresource.com/human-machine-conversations/"
  },
  "headline": "The Next Frontier in Human-Machine Conversations Powered by NLP",
  "description": "Imagine waking up in a world where your coffee machine brews your favorite blend simply because you smiled at it, or your car knows to play your preferred podcast as you buckle your seatbelt.",
  "image": "https://mitresource.com/assets/images/blogs/human-machine-img.webp",  
  "author": {
    "@type": "Organization",
    "name": "Maganti IT",
    "url": "https://mitresource.com/"
  },  
  "publisher": {
    "@type": "Organization",
    "name": "Maganti IT",
    "logo": {
      "@type": "ImageObject",
      "url": "https://mitresource.com/assets/images/homepage/update-mitimage.png"
    }
  },
  "datePublished": "2024-09-27"
}`;
   
    this._renderer2.appendChild(this._document.head, script);

    this.setTitleAndMetaTags();
    this.seoService.createLinkForCanonicalURL();
  
  }
  private setTitleAndMetaTags(): void {
    this.titleService.setTitle('The Next Frontier in Human-Machine Conversations Powered by NLP | Maganti IT');

    this.metaService.addTags([
      { name: 'description', content: 'Traditional maintenance practices often rely on scheduled inspections or reactive fixes when equipment fails.' },
      { property: 'og:type', content: 'website' },
      { property: 'og:title', content: 'The Next Frontier in Human-Machine Conversations Powered by NLP | Maganti IT' },
      { property: 'og:url', content: 'https://mitresource.com/human-machine-conversations/' },
      { property: 'og:image', content: 'https://mitresource.com/assets/images/blogs/human-machine-img.webp' },
      { property: 'og:description', content: 'Imagine waking up in a world where your coffee machine brews your favorite blend simply because you smiled at it, or your car knows to play your preferred podcast as you buckle your seatbelt.' },
    ]);
  }
  scrollToSection(sectionId: string) {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  }
}
